import { useNavigate } from "react-router-dom";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { getEnv } from "helpers/environment";

export let currentAuth0User = null;
export let auth0Client = null;

export const setCurrentAuth0User = (user) => {
  currentAuth0User = user;
};

const Auth0ProviderWithHistory = ({ children }) => {
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();

  const onRedirectCallback = (appState) => {
    navigate((appState && appState.returnTo) || window.location.pathname);
  };

  useEffect(() => {
    auth0Client = { getAccessTokenSilently };
  }, []);

  return (
    <Auth0Provider
      domain={getEnv("AUTH0_DOMAIN")}
      clientId={getEnv("AUTH0_CLIENT_ID")}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: getEnv("AUTH0_AUDIENCE"),
        scope: "openid profile email email_verified offline_access"
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens
      useRefreshTokensFallback
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
